import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import Header from "../layout/Header";
import NotFound from "../pages/NotFound";
import Login from "../pages/Login";
import LandingTC from "../testcenters/LandingTC";
import LandingVC from "../vaccinecenters/LandingVC";

import PrivateRoute from "./PrivateRoute";
import HomeTC from "../dashboard/HomeTC";
import HomeVC from "../dashboard/HomeVC";
import CreateTC from "../dashboard/CreateTC";
import CreateVC from "../dashboard/CreateVC";
import EditTC from "../dashboard/EditTC";
import EditVC from "../dashboard/EditVC";

export default class Routes extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="container">
          <Switch>
            <PrivateRoute exact path="/admin/testcenters" component={HomeTC} />
            <PrivateRoute
              exact
              path="/admin/testcenters/create"
              component={CreateTC}
            />
            <PrivateRoute
              exact
              path="/admin/testcenters/edit/:id"
              component={EditTC}
            />
            <PrivateRoute
              exact
              path="/admin/vaccinecenters"
              component={HomeVC}
            />
            <PrivateRoute
              exact
              path="/admin/vaccinecenters/create"
              component={CreateVC}
            />
            <PrivateRoute
              exact
              path="/admin/vaccinecenters/edit/:id"
              component={EditVC}
            />
            <Route exact path="/" component={LandingVC} />
            {/* <Route exact path="/vaccine-centers" component={LandingVC} /> */}
            <Route exact path="/login" component={Login} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}
